module.exports = __webpack_public_path__ + "img/xitun-elementary-school-director.11bdf3fa.png";